// @flow
import hasPermission from '../globalFunctions/hasPermission';

export default {
  path: '/venda-cantada',
  component: () => import('modules/saleManagement/Index.vue'),
  children: [
    {
      path: '',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'Venda Cantada',
            name: 'SaleManagement'
          }
        ]
      },
      name: 'SaleManagement',
      component: () => import('modules/saleManagement/IconList.vue'),
      // eslint-disable-next-line
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.venda_cantada.dashboard')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: '/venda-cantada/gestao',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'Venda Cantada',
            name: 'SaleManagement'
          },
          {
            text: 'Gestão',
            name: 'SaleManagementView'
          }
        ]
      },
      name: 'SaleManagementView',
      component: () => import('modules/saleManagement/SaleList.vue'),
      // eslint-disable-next-line
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.venda_cantada.dashboard')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: '',
      name: 'SaleManagementDetail',
      component: () => import('modules/saleManagement/InfoSale.vue'),
      // eslint-disable-next-line
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.venda_cantada.dashboard')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: '',
      name: 'SaleManagementEdit',
      component: () => import('modules/saleManagement/EditSale.vue'),
      // eslint-disable-next-line
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.venda_cantada.dashboard')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: '/venda-cantada/log',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'Venda Cantada',
            name: 'SaleManagement'
          },
          {
            text: 'LOG - Gestão de Venda',
            name: 'SaleManagementLog'
          }
        ]
      },
      name: 'SaleManagementLog',
      component: () => import('modules/saleManagement/LogsList.vue'),
      // eslint-disable-next-line
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.venda_cantada.dashboard')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: '',
      name: 'SaleLogDetail',
      component: () => import('modules/saleManagement/InfoSaleLogs.vue'),
      // eslint-disable-next-line
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.venda_cantada.dashboard')) {
          next();
        } else {
          next('/');
        }
      }
    }
  ]
};
